module.exports = __webpack_public_path__ + "img/try_demo_background_mobile.5e8d57c2.png";